<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './assets/css/main.css'

export default {
  name: 'App',
  methods: {
    createPageTitle: function (to) {
      // タイトルを設定
      if (to.meta.title) {
        var setTitle = to.meta.title + ' | ノバセル ブランドガイドライン'
        document.title = setTitle
      } else {
        document.title = 'ノバセル ブランドガイドライン'
      }

      // メタタグdescription設定
      if (to.meta.desc) {
        var setDesc = to.meta.desc
        document.querySelector('meta[name="description"]').setAttribute('content', setDesc)
      } else {
        document.querySelector('meta[name="description"]').setAttribute('content', 'ノバセルのブランドアセットをダウンロードしたり、使用する際に注意すべき点を知ることができます')
      }
    }
  },
  mounted: function () {
    var to = this.$route
    this.createPageTitle(to)
  },
  watch: {
    '$route' (to, from) {
      this.createPageTitle(to)
    }
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue